import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CorporateSection() {
  const { t } = useTranslation();
  return (
    <section className="relative py-16 md:py-20 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="border border-background-200/60 bg-background-100/60 p-8 md:p-10">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div className="flex-1">
              <p className="text-accent-600 text-[13px] tracking-[0.15em] mb-3 font-label">
                FOR CORPORATIONS
              </p>
              <h2 className="font-heading text-[16px] text-foreground-900 tracking-[0.06em] mb-3">
                {t('about.corporate.title')}
              </h2>
              {String(t('about.corporate.body')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed mb-2">{__s}</p>))}
              {String(t('about.corporate.note')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-400 tracking-[0.04em] leading-relaxed">{__s}</p>))}
            </div>
            <Link
              to="/corporate"
              className="inline-flex items-center gap-3 px-8 py-3.5 bg-accent-500 hover:bg-accent-400 text-primary-900 text-[15px] tracking-[0.08em] font-medium transition-all duration-300 whitespace-nowrap cursor-pointer btn-glow flex-shrink-0"
            >
              {t('about.corporate.cta')}
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}